export type LegacyManagementScheduleType = '1' | '2'

export type LegacyManagementOffice = {
  id: string
  name: string
}

export type LegacyManagementStatus = {
  code: string
  label: string
  color: string
}

export type LegacyManagementScheduleRow = {
  id: string
  type: LegacyManagementScheduleType
  officeId: string
  officeName: string
  worker: string
  workgroup: string
  date: string
  time: string
  customer: string
  customerId: string
  title: string
  memo: string
  statusCode: string
  statusLabel: string
  color: string
  scheduleId: string
  workgroupId: string
  staffId: string
}

export const legacyWorkScheduleManagementOffices: LegacyManagementOffice[] = [
  { id: 'mock-office-a', name: 'Mock 지점 A' },
  { id: 'mock-office-b', name: 'Mock 지점 B' },
  { id: 'mock-office-c', name: 'Mock 지점 C' },
]

export const legacyWorkScheduleManagementStatuses: LegacyManagementStatus[] = [
  { code: '0', label: '미완료', color: '#000000' },
  { code: '1', label: '완료', color: '#6f6f6f' },
  { code: '2', label: '연기', color: '#919191' },
  { code: '3', label: '취소', color: '#ff164b' },
  { code: '4', label: '변경', color: '#ff743d' },
  { code: '5', label: '노쇼', color: '#ad49d4' },
  { code: '6', label: '2주', color: '#3278d5' },
  { code: '7', label: 'OK', color: '#00a69b' },
]

function formatDate(year: number, month: number, day: number) {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
}

export function getLegacyManagementMonthRange(reference = new Date()) {
  const year = reference.getFullYear()
  const month = reference.getMonth() + 1
  const lastDay = new Date(year, month, 0).getDate()
  return {
    startDate: formatDate(year, month, 1),
    endDate: formatDate(year, month, lastDay),
    year,
    month,
    lastDay,
  }
}

const monthRange = getLegacyManagementMonthRange()

function makeRows(type: LegacyManagementScheduleType, count: number): LegacyManagementScheduleRow[] {
  return Array.from({ length: count }, (_, index) => {
    const office = legacyWorkScheduleManagementOffices[index % legacyWorkScheduleManagementOffices.length]
    const nonCompleteStatuses = legacyWorkScheduleManagementStatuses.filter(({ code }) => code !== '1')
    const status = index < 39
      ? legacyWorkScheduleManagementStatuses.find(({ code }) => code === '1')!
      : nonCompleteStatuses[(index - 39) % nonCompleteStatuses.length]
    const sequence = index + 1
    const day = 1 + (index % monthRange.lastDay)
    const hour = 9 + (index % 9)
    const minute = index % 2 === 0 ? '00' : '30'
    const customerId = index % 7 === 0 ? '' : `mock-customer-${String(sequence).padStart(4, '0')}`

    return {
      id: `${type === '1' ? 'work' : 'normal'}-management-${sequence}`,
      type,
      officeId: office.id,
      officeName: office.name,
      worker: `Mock 작업자 ${String.fromCharCode(65 + (index % 8))}`,
      workgroup: `Mock 작업그룹 ${String.fromCharCode(65 + (index % 5))}`,
      date: formatDate(monthRange.year, monthRange.month, day),
      time: `${String(hour).padStart(2, '0')}:${minute}`,
      customer: customerId ? `Mock 고객 ${String.fromCharCode(65 + (index % 12))}` : '-',
      customerId,
      title: `Mock ${type === '1' ? '업무' : '일반'} 일정 ${sequence}`,
      memo: `Mock ${type === '1' ? '업무' : '일반'} 일정 내용`,
      statusCode: status.code,
      statusLabel: status.label,
      color: status.color,
      scheduleId: `mock-schedule-${type}-${String(sequence).padStart(4, '0')}`,
      workgroupId: `mock-workgroup-${(index % 5) + 1}`,
      staffId: `mock-staff-${(index % 8) + 1}`,
    }
  })
}

/** 실제 API나 운영 정보를 사용하지 않는 완료 일정 관리용 비식별 Mock 목록. */
export const legacyWorkScheduleManagementRows: LegacyManagementScheduleRow[] = [
  ...makeRows('1', 960),
  ...makeRows('2', 960),
]
